import { useParams } from 'react-router-dom';
import { useSessionDetails } from '@hooks/data/useSessionDetails';
import { isProjectSelection } from '@fe-learner-common/api/schemas/sessionsSchema';
import { CourseSessionDetails } from '@routes/session-details/CourseSessionDetails';
import { ProjectSelectionSessionDetails } from '@routes/session-details/ProjectSelectionSessionDetails';

export const SessionDetailsRoute = () => {
  const { sessionId } = useParams();

  const { data: sessionDetails } = useSessionDetails({
    enabled: true,
    sessionId,
  });

  if (!sessionDetails) {
    return null;
  }

  return isProjectSelection(sessionDetails) ? (
    <ProjectSelectionSessionDetails sessionDetails={sessionDetails} />
  ) : (
    <CourseSessionDetails sessionDetails={sessionDetails} />
  );
};
